import { createSelector } from '@ngrx/store';

export const getPropertyGeneralState = createSelector(
    (state: any) => state.dashboard,
    (state: any) => state.get('propertyGeneral')
);

export const getBusinessGeneralState = createSelector(
    (state: any) => state.dashboard,
    (state: any) => state.get('businessGeneral')
);

